<template>
  <div>
    <SettingGroup title="">
      <SettingItem label="接続完了トーン">
        <ToggleSwitch
          v-model="form.toggle.connectedTone"
          :disable="false"
        />
      </SettingItem>

      <SettingItem label="圏外警告トーン">
        <ToggleSwitch
          v-model="form.toggle.outOfRangeWarningTone"
          :disable="false"
        />
        <RadioGroup
          :value="form.radioBtn.outOfRangeWarningTone"
          :options="radioBtnOptions.outOfRangeWarningTone"
          :disable="!form.toggle.outOfRangeWarningTone"
          @input="val => form.radioBtn.outOfRangeWarningTone = val"
        />
      </SettingItem>
    </SettingGroup>
  </div>
</template>

<script>
import RadioGroup from '@/components/pc/radio/ipradio/atoms/RadioGroup.vue'
import ToggleSwitch from '@/components/pc/radio/ipradio/atoms/ToggleSwitch.vue'
import SettingGroup from '@/components/pc/radio/ipradio/organisms/layout/SettingGroup.vue'
import SettingItem from '@/components/pc/radio/ipradio/organisms/layout/SettingItem.vue'
import { BC, BC_TRANS_JP } from '@/components/pc/radio/ipradio/config/BCconstants'
import { useRadioSettingsStore } from '@/components/pc/radio/ipradio/stores/bcRadioSettings'
import { mapStores } from 'pinia'

export default {
  name: 'NetworkToneVue2',
  components: { RadioGroup, ToggleSwitch, SettingGroup, SettingItem },
  data () {
    const radioBtnOptions = {
      outOfRangeWarningTone: Object
        .keys(BC.NETWORK.TONE.OUT_OF_RANGE_WARNING_TONE)
        .filter(key => key !== 'DISABLE')
        .map(key => ({
          label: BC_TRANS_JP.NETWORK.TONE.OUT_OF_RANGE_WARNING_TONE[key],
          value: BC.NETWORK.TONE.OUT_OF_RANGE_WARNING_TONE[key],
        })),
    }

    return {
      radioBtnOptions,
      form: {
        radioBtn: {
          outOfRangeWarningTone: radioBtnOptions.outOfRangeWarningTone[0].value,
        },
        toggle: {
          connectedTone: false,
          outOfRangeWarningTone: false,
        },
      },
      setting: null, // ストアの一時設定
    }
  },
  computed: {
    ...mapStores(useRadioSettingsStore),
  },
  created () {
    // ストアから設定取得
    this.setting = this.radioSettingsStore.getTempSetting()

    // 設定 → フォーム
    this.transSetting2Form()

    // フォーム変更を監視：設定へ反映 & 保存
    this.$watch('form', () => {
      this.transForm2Setting()
      this.radioSettingsStore.saveTempSetting(this.setting)
    }, { deep: true })
  },
  methods: {
    // 設定 ← フォーム
    transForm2Setting () {
      const data = this.setting?.Network?.Tone
      if (!data) return

      data.ConnectedTone = this.form.toggle.connectedTone
        ? BC.COMMON.TOGGLE.ENABLE
        : BC.COMMON.TOGGLE.DISABLE

      data.OutOfRangeWarningTone = this.form.toggle.outOfRangeWarningTone
        ? this.form.radioBtn.outOfRangeWarningTone
        : BC.COMMON.TOGGLE.DISABLE
    },

    // 設定 → フォーム
    transSetting2Form () {
      const data = this.setting?.Network?.Tone
      if (!data) return

      this.form.toggle.connectedTone = data.ConnectedTone === BC.COMMON.TOGGLE.ENABLE

      this.form.toggle.outOfRangeWarningTone =
        data.OutOfRangeWarningTone !== BC.COMMON.TOGGLE.DISABLE

      this.form.radioBtn.outOfRangeWarningTone =
        data.OutOfRangeWarningTone !== BC.COMMON.TOGGLE.DISABLE
          ? data.OutOfRangeWarningTone
          : BC.NETWORK.TONE.OUT_OF_RANGE_WARNING_TONE.REPEAT
    },
  },
}
</script>
